import { handleActions } from "redux-actions";

import { setBranches } from "./actions";

const initialState = {
    isLoadingBranch: false,
    codes: [],
    branches: {}
};

export const branchReducer = handleActions(
    {
        [setBranches]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);